import React from 'react';
import {
  List,
  Datagrid,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  BooleanInput,
  TextField,
  translate as t,
} from 'admin-on-rest';

import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import TranslatableInput from '../components/inputs/TranslatableInput';
import Section from '../components/utils/Section';
import TranslatableField from '../components/fields/TranslatableField';
import ImageInput from '../components/inputs/ImageInput';
import ThumbnailImageField from '../components/fields/ThumbnailImageField';

export const WebPromosList = t((props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="internalName" />
      <TranslatableField source="headingBold" />
      <EditButton {...props} />
      <DeleteButton {...props} />
    </Datagrid>
  </List>
));

export const WebPromosEdit = t((props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="internalName" />
      <TranslatableInput {...props} source="tag" />
      <TranslatableInput {...props} source="headingBold" />
      <TranslatableInput {...props} source="headingThin" />

      <ImageInput source="imageWide" label={props.translate('website.imageWide')} accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>
      <ImageInput source="imageSquare" label={props.translate('website.imageSquare')} accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>

      <Section title="web-promo.button" {...props}>
        <BooleanInput source="button.show" />
        <BooleanInput source="button.internal" />
        <TranslatableInput {...props} source="button.text" />
        <TextInput source="button.link" />
      </Section>
      <Section title={props.translate('website.appPromotion')} {...props}>
        <BooleanInput source="appPromotion.show" label={props.translate('website.show')} />
        <TextInput source="appPromotion.androidLink" label={props.translate('website.androidLink')} />
        <TextInput source="appPromotion.iosLink" label={props.translate('website.iosLink')} />
      </Section>
    </SimpleForm>
  </Edit>
));

export const WebPromosCreate = t((props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="internalName" />
      <TranslatableInput {...props} source="tag" />
      <TranslatableInput {...props} source="headingBold" />
      <TranslatableInput {...props} source="headingThin" />

      <ImageInput source="imageWide" label={props.translate('website.imageWide')} accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>
      <ImageInput source="imageSquare" label={props.translate('website.imageSquare')} accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>

      <Section title="web-promo.button" {...props}>
        <BooleanInput source="button.show" />
        <BooleanInput source="button.internal" />
        <TranslatableInput {...props} source="button.text" />
        <TextInput source="button.link" />
      </Section>
      <Section title={props.translate('website.appPromotion')} {...props}>
        <BooleanInput source="appPromotion.show" label={props.translate('website.show')} />
        <TextInput source="appPromotion.androidLink" label={props.translate('website.androidLink')} />
        <TextInput source="appPromotion.iosLink" label={props.translate('website.iosLink')} />
      </Section>
    </SimpleForm>
  </Create>
));
